import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormDropdown, FormFields, mapToDropdownOption } from "sprint-common-web";

import { DeliveryEndpointType } from "../../../../../common/types/DeliveryEndpointType";
import { useEditSmartjogDeliveryInfoForm } from "./useEditSmartjogDeliveryInfoForm";

export interface EditDeliveryInfoFormProps {
    onCancel(): void;
    onSubmit(): void;
}

export interface EditSmartjogDeliveryInfoFormInputs {
    type: string;
    deliveryEndpointId: string;
    distributionListId: string;
}

export const EditSmartjogDeliveryInfoForm: React.VFC<EditDeliveryInfoFormProps> = ({
    onSubmit,
    onCancel
}: EditDeliveryInfoFormProps) => {
    const {
        itemToEdit,
        deliveryEndpoints,
        distributionLists,
        editSmartjogDeliveryInfo,
        resetDistributionListOptions
    } = useEditSmartjogDeliveryInfoForm();

    useEffect(() => {
        if (itemToEdit.deliveryEndpoint?.type === DeliveryEndpointType.Smartjog)
            resetDistributionListOptions(itemToEdit.deliveryEndpoint?.id);
    }, []);

    const { errors, control, formState, handleSubmit } = useForm<EditSmartjogDeliveryInfoFormInputs>({
        defaultValues: {
            deliveryEndpointId: itemToEdit?.deliveryEndpoint?.id ?? "",
            distributionListId: itemToEdit?.distributionList?.id ?? ""
        },
        criteriaMode: "all"
    });

    const handleEditDeliveryInfo = async (inputs: EditSmartjogDeliveryInfoFormInputs) => {
        await editSmartjogDeliveryInfo(inputs);
        onSubmit();
    };

    const handleSmartjogDeliveryEndpointSelected = (deliveryEndpointId: string) => {
        if (deliveryEndpointId) {
            resetDistributionListOptions(deliveryEndpointId);
        }
    };

    const handleCancelButtonClick = () => {
        onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(handleEditDeliveryInfo)}>
            <FormFields>
                <FormDropdown
                    options={deliveryEndpoints.map((item) => mapToDropdownOption(item))}
                    label="Delivery endpoint"
                    name="deliveryEndpointId"
                    control={control}
                    errors={errors}
                    onChange={handleSmartjogDeliveryEndpointSelected}
                    rules={{ required: "Select delivery endpoint" }}
                />
                <FormDropdown
                    options={distributionLists.map((item) => mapToDropdownOption(item))}
                    label="Distribution List"
                    name="distributionListId"
                    control={control}
                    errors={errors}
                    rules={{ required: "Select distribution list" }}
                />
            </FormFields>
            <FormActions
                isLoading={formState.isValidating || formState.isSubmitting}
                onCancel={handleCancelButtonClick}
            />
        </Form>
    );
};
